export const sanityString = (value) => {
    if (value == null || value === '') {
        return null;
    }
    return value.toString();
}

export const sanityStringLowerCase = (value) => {
    if (value == null || value === '') {
        return null;
    }
    return value.toString().toLowerCase();
}

export const sanityStringNoSpace = (value) => {
    if (value == null || value === '') {
        return null;
    }
    return value.toString().replace(/\s/g, '');
}

export const sanityStringLowerCaseNoSpace = (value) => {
    return sanityStringNoSpace(sanityStringLowerCase(value));
}

export const sanityStringNumbersAndLetters = (value) => {
    value = sanityString(value);
    if (value == null) {
        return value;
    }
    return value.replace(/[^a-zA-Z0-9]/g, '');
}

export const sanityStringNumbersAndLettersSquished = (value) => {
    value = sanityStringNumbersAndLetters(value);
    if (value == null) {
        return value;
    }
    return sanityStringNoSpace(value);
}

export const sanityStringNumbersAndLettersSquishedLowerCase = (value) => {
    value = sanityStringNumbersAndLettersSquished(value);
    if (value == null) {
        return value;
    }
    return sanityStringLowerCaseNoSpace(value);
}

export const isStringNumber = (string) => {
    if (string == null) {
        return false;
    }
    return /^\d+$/.test(string);
};
